import Cookies from 'universal-cookie'

const cookies = new Cookies()
export const getAuth = () => {
  const auth = cookies.get('app_user_auth')
  if (auth === 'null' || auth === 'undefined' || !auth) {
    return ''
  }
  return auth
}
export const getVersion = () => {
  const version = cookies.get('app_version')
  if (version === 'null' || version === 'undefined' || !version) {
    return '1.8.1'
  }
  return version
}
export const getCheckinID = () => {
  const checkin_id = cookies.get('checkin_id')
  if (checkin_id === 'null' || checkin_id === 'undefined' || !checkin_id) {
    return null
  }
  return checkin_id
}
export const getMallKey = () => {
  const key = cookies.get('app_sign_key_mall')
  if (key === 'null' || key === 'undefined' || !key) {
    return null
  }
  return key
}

export const getSanyPhone = () => {
  const phone = cookies.get('sany_phone')
  if (phone === 'null' || phone === 'undefined' || !phone) {
    return ''
  }
  return phone
}